import {
  CRITICAL,
  MEDIUM,
  LOW,
  HIGH,
  BLUE,
  GREY,
  ARMIS_CRITICAL,
  ARMIS_HIGH,
  ARMIS_MEDIUM,
  ARMIS_LOW,
  JIRA,
  SEEM,
  NTTGN,
  ZENDESK,
  AZUREDEVOPS,
  SERVICENOW,
  MONDAY,
  ARMIS,
  JIRALong,
  SEEMPLICITYLong,
  NTTGNLong,
  ZENDESKLong,
  MONDAYLong,
  AZUREDEVOPSLong,
  SERVICENOWLong,
  SLACKLong,
  SLACK,
  BMCHELIX,
  BMCHELIXLong,
  CONNECTWISE,
  CONNECTWISELong,
  IVANTI,
  IVANTILong,
  GIT,
  GITLong,
  JIRA_ON_PREM,
  JIRA_ON_PREMLong,
  // Dark versions
  JIRA_DARK,
  JIRA_ON_PREM_DARK,
  ZENDESK_DARK,
  AZUREDEVOPS_DARK,
  SERVICENOW_DARK,
  BMCHELIX_DARK,
  IVANTI_DARK,
  MONDAY_DARK,
  SLACK_DARK,
  CONNECTWISE_DARK,
  GIT_DARK,
  JIRA_LONG_DARK,
  JIRA_ON_PREM_LONG_DARK,
  ZENDESK_LONG_DARK,
  AZUREDEVOPS_LONG_DARK,
  SERVICENOW_LONG_DARK,
  BMCHELIX_LONG_DARK,
  IVANTI_LONG_DARK,
  MONDAY_LONG_DARK,
  SLACK_LONG_DARK,
  CONNECTWISE_LONG_DARK,
  GIT_LONG_DARK,
  NTTGN_DARK,
  SEEM_DARK,
  SEEMPLICITYLongDark,
  NTTGNLongDark,
  FRESHSERVICE,
  FRESHSERVICELong,
  FRESHSERVICE_DARK,
  FRESHSERVICE_LONG_DARK,
  SERVICE_DESK_ON_PREM,
  SERVICE_DESK_ON_PREMLong,
  SERVICE_DESK_ON_PREM_DARK,
  SERVICE_DESK_ON_PREM_LONG_DARK,
  TEAMDYNAMIX,
  TEAMDYNAMIXLong,
  TEAMDYNAMIX_DARK,
  TEAMDYNAMIX_LONG_DARK,
} from "../icons/TicketingIcons/TicketingIcons";

//**** BE AWARE! This file contains duplications with APPLICATION ****//

export type DataSourceIconSize = "S" | "L";

interface DataSourceIconVariant {
  S: string;
  L: string;
  name: string;
}

interface DataSourceIconEntry {
  LIGHT: DataSourceIconVariant;
  DARK: DataSourceIconVariant;
}

export const dataSourceIcons: Record<string, DataSourceIconEntry> = {
  JIRA: {
    LIGHT: { S: JIRA, L: JIRALong, name: "" },
    DARK: { S: JIRA_DARK, L: JIRA_LONG_DARK, name: "" },
  },
  JIRA_ON_PREM: {
    LIGHT: { S: JIRA_ON_PREM, L: JIRA_ON_PREMLong, name: "" },
    DARK: { S: JIRA_ON_PREM_DARK, L: JIRA_ON_PREM_LONG_DARK, name: "" },
  },
  AZURE_DEVOPS: {
    LIGHT: { S: AZUREDEVOPS, L: AZUREDEVOPSLong, name: "" },
    DARK: { S: AZUREDEVOPS_DARK, L: AZUREDEVOPS_LONG_DARK, name: "" },
  },
  SLACK: {
    LIGHT: { S: SLACK, L: SLACKLong, name: "" },
    DARK: { S: SLACK_DARK, L: SLACK_LONG_DARK, name: "" },
  },
  MONDAY: {
    LIGHT: { S: MONDAY, L: MONDAYLong, name: "" },
    DARK: { S: MONDAY_DARK, L: MONDAY_LONG_DARK, name: "" },
  },
  SERVICENOW: {
    LIGHT: { S: SERVICENOW, L: SERVICENOWLong, name: "" },
    DARK: { S: SERVICENOW_DARK, L: SERVICENOW_LONG_DARK, name: "" },
  },
  NTTGN: {
    LIGHT: { S: NTTGN, L: NTTGNLong, name: "" },
    DARK: { S: NTTGN_DARK, L: NTTGNLongDark, name: "" },
  },
  ZENDESK: {
    LIGHT: { S: ZENDESK, L: ZENDESKLong, name: "" },
    DARK: { S: ZENDESK_DARK, L: ZENDESK_LONG_DARK, name: "" },
  },
  SEEMPLICITY: {
    LIGHT: { S: SEEM, L: SEEMPLICITYLong, name: "" },
    DARK: { S: SEEM_DARK, L: SEEMPLICITYLongDark, name: "" },
  },
  BMC_HELIX: {
    LIGHT: { S: BMCHELIX, L: BMCHELIXLong, name: "" },
    DARK: { S: BMCHELIX_DARK, L: BMCHELIX_LONG_DARK, name: "" },
  },
  CONNECTWISE: {
    LIGHT: { S: CONNECTWISE, L: CONNECTWISELong, name: "" },
    DARK: { S: CONNECTWISE_DARK, L: CONNECTWISE_LONG_DARK, name: "" },
  },
  IVANTI: {
    LIGHT: { S: IVANTI, L: IVANTILong, name: "" },
    DARK: { S: IVANTI_DARK, L: IVANTI_LONG_DARK, name: "" },
  },
  GITHUB_ISSUES: {
    LIGHT: { S: GIT, L: GITLong, name: "" },
    DARK: { S: GIT_DARK, L: GIT_LONG_DARK, name: "" },
  },
  FRESHSERVICE: {
    LIGHT: { S: FRESHSERVICE, L: FRESHSERVICELong, name: "" },
    DARK: { S: FRESHSERVICE_DARK, L: FRESHSERVICE_LONG_DARK, name: "" },
  },
  SERVICE_DESK_ON_PREM: {
    LIGHT: { S: SERVICE_DESK_ON_PREM, L: SERVICE_DESK_ON_PREMLong, name: "" },
    DARK: {
      S: SERVICE_DESK_ON_PREM_DARK,
      L: SERVICE_DESK_ON_PREM_LONG_DARK,
      name: "",
    },
  },
  TEAMDYNAMIX: {
    LIGHT: { S: TEAMDYNAMIX, L: TEAMDYNAMIXLong, name: "" },
    DARK: { S: TEAMDYNAMIX_DARK, L: TEAMDYNAMIX_LONG_DARK, name: "" },
  },
};

export const systemOptionsEnum = {
  SEEMPLICITY: "Seemplicity",
  ARMIS: "Armis",
} as const;

export const ticketEndpointContextEnum = {
  MANUAL_TICKET: "CREATE_TICKET",
  RMQ: "CREATE_RMQ",
} as const;

export const ticketEndpointTypeEnum = {
  REPORT: "REPORT",
  TICKET: "TICKET",
  INTERNAL: "INTERNAL",
} as const;

export const integrationTypeToPageLinkMap: Record<string, string> = {
  [ticketEndpointTypeEnum.TICKET]: "ticketing",
  [ticketEndpointTypeEnum.REPORT]: "reports",
  [ticketEndpointTypeEnum.INTERNAL]: "views",
};

interface TicketingIconEntry {
  LIGHT: { S: string };
  DARK: { S: string };
}

export const ticketingIcons: Record<string, TicketingIconEntry> = {
  "jira-mark": { LIGHT: { S: JIRA }, DARK: { S: JIRA_DARK } },
  "nttgn-mark": { LIGHT: { S: NTTGN }, DARK: { S: NTTGN_DARK } },
  "armis-mark": { LIGHT: { S: ARMIS }, DARK: { S: ARMIS } },
  "zendesk-mark": { LIGHT: { S: ZENDESK }, DARK: { S: ZENDESK_DARK } },
  "monday-mark": { LIGHT: { S: MONDAY }, DARK: { S: MONDAY_DARK } },
  "azure-devops-mark": {
    LIGHT: { S: AZUREDEVOPS },
    DARK: { S: AZUREDEVOPS_DARK },
  },
  "seemplicity-mark": { LIGHT: { S: SEEM }, DARK: { S: SEEM_DARK } },
  "bmc-helix-mark": { LIGHT: { S: BMCHELIX }, DARK: { S: BMCHELIX_DARK } },
  "servicenow-mark": { LIGHT: { S: SERVICENOW }, DARK: { S: SERVICENOW_DARK } },
  "ivanti-mark": { LIGHT: { S: IVANTI }, DARK: { S: IVANTI_DARK } },
  "github-issues-mark": { LIGHT: { S: GIT }, DARK: { S: GIT_DARK } },
  "freshservice-mark": {
    LIGHT: { S: FRESHSERVICE },
    DARK: { S: FRESHSERVICE_DARK },
  },
  "service-desk-on-prem-mark": {
    LIGHT: { S: SERVICE_DESK_ON_PREM },
    DARK: { S: SERVICE_DESK_ON_PREM_DARK },
  },
  "teamdynamix-mark": {
    LIGHT: { S: TEAMDYNAMIX },
    DARK: { S: TEAMDYNAMIX_DARK },
  },
  red_button: { LIGHT: { S: CRITICAL }, DARK: { S: CRITICAL } },
  yellow_button: { LIGHT: { S: MEDIUM }, DARK: { S: MEDIUM } },
  orange_button: { LIGHT: { S: HIGH }, DARK: { S: HIGH } },
  green_button: { LIGHT: { S: LOW }, DARK: { S: LOW } },
  blue_button: { LIGHT: { S: BLUE }, DARK: { S: BLUE } },
  grey_button: { LIGHT: { S: GREY }, DARK: { S: GREY } },
  armis_critical: {
    LIGHT: { S: ARMIS_CRITICAL },
    DARK: { S: ARMIS_CRITICAL },
  },
  armis_high: { LIGHT: { S: ARMIS_HIGH }, DARK: { S: ARMIS_HIGH } },
  armis_medium: { LIGHT: { S: ARMIS_MEDIUM }, DARK: { S: ARMIS_MEDIUM } },
  armis_low: { LIGHT: { S: ARMIS_LOW }, DARK: { S: ARMIS_LOW } },
};

const ticketStatusNames: Record<string, string> = {
  backlog_ticket_status: "backlog",
  scheduled_ticket_status: "scheduled",
  in_progress_ticket_status: "in_progress",
  done_ticket_status: "done",
  rejected_ticket_status: "rejected",
};

export const ticketingIconClassNames: Record<string, string> = {
  red_button: "round-dot critical",
  yellow_button: "round-dot medium",
  orange_button: "round-dot high",
  green_button: "round-dot low",
  blue_button: "round-dot informational",
  grey_button: "round-dot no-priority",
};

export const getTicketStatusName = (iconName?: string): string | undefined =>
  iconName ? ticketStatusNames[iconName] : undefined;

export const ticketManagersEnum = {
  JIRA: "JIRA",
  JIRA_ON_PREM: "JIRA_ON_PREM",
  MONDAY: "MONDAY",
  SERVICENOW: "SERVICENOW",
  IVANTI: "IVANTI",
  GITHUB_ISSUES: "GITHUB_ISSUES",
  FRESHSERVICE: "FRESHSERVICE",
  SERVICE_DESK_ON_PREM: "SERVICE_DESK_ON_PREM",
  TEAMDYNAMIX: "TEAMDYNAMIX",
  SLACK: "SLACK",
  FIBERY: "FIBERY",
  ZENDESK: "ZENDESK",
  NTTGN: "NTTGN",
  AZURE_DEVOPS: "AZURE_DEVOPS",
  MICROSOFT_TEAMS: "MS_TEAMS",
  BMC_HELIX: "BMC_HELIX",
  EMAIL: "EMAIL",
  SEEMPLICITY: "SEEMPLICITY",
} as const;

interface TicketManager {
  label: string;
  value: string;
  name: string;
  friendlyName: string;
}

export const ticketManagers: TicketManager[] = [
  {
    label: "",
    value: ticketManagersEnum.SEEMPLICITY,
    name: ticketManagersEnum.SEEMPLICITY,
    friendlyName: "Seemplicity",
  },
  {
    label: "",
    value: ticketManagersEnum.EMAIL,
    name: ticketManagersEnum.EMAIL,
    friendlyName: "Email",
  },
  {
    label: "",
    value: ticketManagersEnum.MICROSOFT_TEAMS,
    name: ticketManagersEnum.MICROSOFT_TEAMS,
    friendlyName: "Teams",
  },
  {
    label: "",
    value: ticketManagersEnum.JIRA_ON_PREM,
    name: ticketManagersEnum.JIRA_ON_PREM,
    friendlyName: "Jira On Prem",
  },
  {
    label: "",
    value: ticketManagersEnum.JIRA,
    name: ticketManagersEnum.JIRA,
    friendlyName: "Jira",
  },
  {
    label: "",
    value: ticketManagersEnum.MONDAY,
    name: ticketManagersEnum.MONDAY,
    friendlyName: "Monday",
  },
  {
    label: "",
    value: ticketManagersEnum.SERVICENOW,
    name: ticketManagersEnum.SERVICENOW,
    friendlyName: "Service Now",
  },
  {
    label: "",
    value: ticketManagersEnum.IVANTI,
    name: ticketManagersEnum.IVANTI,
    friendlyName: "Ivanti",
  },
  {
    label: "",
    value: ticketManagersEnum.GITHUB_ISSUES,
    name: ticketManagersEnum.GITHUB_ISSUES,
    friendlyName: "Github Issues",
  },
  {
    label: "",
    value: ticketManagersEnum.FRESHSERVICE,
    name: ticketManagersEnum.FRESHSERVICE,
    friendlyName: "Freshservice",
  },
  {
    label: "",
    value: ticketManagersEnum.SERVICE_DESK_ON_PREM,
    name: ticketManagersEnum.SERVICE_DESK_ON_PREM,
    friendlyName: "Service Desk On Prem",
  },
  {
    label: "",
    value: ticketManagersEnum.SLACK,
    name: ticketManagersEnum.SLACK,
    friendlyName: "Slack",
  },
  {
    label: "",
    value: ticketManagersEnum.ZENDESK,
    name: ticketManagersEnum.ZENDESK,
    friendlyName: "Zendesk",
  },
  {
    label: "",
    value: ticketManagersEnum.NTTGN,
    name: ticketManagersEnum.NTTGN,
    friendlyName: "NTTGN",
  },
  {
    label: "",
    value: ticketManagersEnum.AZURE_DEVOPS,
    name: ticketManagersEnum.AZURE_DEVOPS,
    friendlyName: "Azure Devops",
  },
];

export const getTicketManagerFriendlyName = (
  ticketManagerValue: string
): string | undefined =>
  ticketManagers.find((el) => el.value === ticketManagerValue)?.friendlyName;

export const getKeysThatHoldsValue = <T>(
  availableKeys: Record<string, T>
): Record<string, T> => {
  return Object.keys(availableKeys)
    ?.filter((key) => !!availableKeys?.[key])
    ?.reduce<Record<string, T>>(
      (acc, key) => ({ ...acc, [key]: availableKeys?.[key] }),
      {}
    );
};

interface MappingKeyOption {
  id: string;
  name: string;
}

interface MappingKeyProps {
  options?: MappingKeyOption[];
}

// `getKeyProps` is typed structurally-loose (returns `object`) to stay
// compatible with consumers (e.g. MappingAlert passes `(fieldName) => object`).
// We narrow the returned value to MappingKeyProps before reading `.options`.
export const getKeysDisplayForMapping = (
  keys: Record<string, string>,
  getKeyProps?: (key: string) => object | undefined
): (string | undefined)[] => {
  return Object.keys(keys)?.map(
    (key) =>
      (getKeyProps?.(key) as MappingKeyProps | undefined)?.options?.find(
        (option) => option.id === keys[key]
      )?.name
  );
};

export const getDataSourceIcon = (
  iconName: string,
  size: DataSourceIconSize
): string | undefined => {
  const currentThemeClass = window.localStorage.getItem("current_theme_ls");
  const currentTheme = currentThemeClass === "theme-dark" ? "DARK" : "LIGHT";

  return dataSourceIcons[iconName]?.[currentTheme || "LIGHT"]?.[size];
};

export const getTicketingIcon = (
  iconName: string,
  size: "S"
): string | undefined => {
  const currentThemeClass = window.localStorage.getItem("current_theme_ls");
  const currentTheme = currentThemeClass === "theme-dark" ? "DARK" : "LIGHT";

  return ticketingIcons[iconName]?.[currentTheme || "LIGHT"]?.[size];
};
